import React from 'react';
import PropTypes from 'prop-types';
import {
  DEFAULT_PAGE_INDEX,
  DEFAULT_PAGE_SIZE,
} from '@tenant/utility/constants/default';
import { Autocomplete, Pagination, TextField, Typography } from '@mui/material';

const pageSizeSelects = [
  {
    label: '10 Results per page',
    value: 10,
  },
  {
    label: '20 Results per page',
    value: 20,
  },
  {
    label: '30 Results per page',
    value: 30,
  },
  {
    label: '50 Results per page',
    value: 50,
  },
];

const AppPagination = ({
  loading = false,
  isChangePageSize = false,
  totalCount,
  pageSize = DEFAULT_PAGE_SIZE,
  pageIndex = DEFAULT_PAGE_INDEX,
  onPageChange = () => {},
  onPageSizeChange = () => {},
  ...rest
}) => {
  return (
    <>
      <Pagination
        count={Math.ceil(totalCount / pageSize) || 0}
        page={pageIndex}
        disabled={loading}
        onChange={(e, v) => onPageChange(v)}
        showFirstButton
        showLastButton
        {...rest}
      />

      {isChangePageSize ? (
        <Autocomplete
          disabled={loading}
          value={
            pageSize ? pageSizeSelects.find((e) => e.value === pageSize) : null
          }
          disablePortal
          disableClearable
          options={pageSizeSelects}
          size='small'
          isOptionEqualToValue={(option, value) => option.value === value.value}
          sx={{ width: 200, ml: 2 }}
          renderInput={(params) => <TextField {...params} />}
          renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;
            return (
              <li {...optionProps} key={option.value}>
                {option.label}
              </li>
            );
          }}
          onChange={onPageSizeChange}
        />
      ) : (
        <Typography>Total: {totalCount || 0}</Typography>
      )}
    </>
  );
};

export default React.memo(AppPagination);

AppPagination.propTypes = {
  isChangePageSize: PropTypes.bool,
  loading: PropTypes.bool,
  totalCount: PropTypes.number,
  pageSize: PropTypes.number,
  pageIndex: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
};
